// Custom functionality for recommended products
document.addEventListener('DOMContentLoaded', function() {
  const predictiveSearch = document.querySelector('predictive-search');
  if (!predictiveSearch) return;

  const recommendedProducts = document.querySelector('[data-recommended-products]');
  const searchInput = predictiveSearch.querySelector('[data-search-input]');

  if (!recommendedProducts || !searchInput) return;

  // Show recommended products initially
  recommendedProducts.classList.remove('hidden');

  // Listen for input changes
  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.trim();

    if (searchTerm.length > 0) {
      // Hide recommended products when searching
      recommendedProducts.classList.add('hidden');
    } else {
      // Show recommended products when input is empty
      recommendedProducts.classList.remove('hidden');
    }
  });

  // Also listen for when predictive search opens/closes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'open') {
        const isOpen = predictiveSearch.hasAttribute('open');
        const hasSearchTerm = searchInput.value.trim().length > 0;

        if (isOpen && !hasSearchTerm) {
          recommendedProducts.classList.remove('hidden');
        }
      }
    });
  });

  observer.observe(predictiveSearch, { attributes: true });
});
